export default "__VITE_ASSET__$nIhXcfN__"